import React from 'react';

export function processAllSkills(characters, buffs) {
    const skillKeys = ["hidden", "special", "skill1", "skill2", "combo", "normal", "gear1", "gear2"];
    for (const character of Object.values(characters)) {
        for (const skillKey of skillKeys) {
            const skill = character[skillKey];
            if (skill) {
                for (const key of ['a0', 'ax']) {
                    if (skill[key]) {
                        character[skillKey][`${key}_skills`] = Array.isArray(skill[key])
                            ? Object.values(skill[key]).map(item => createSkill(item, buffs))
                            : createSkill(skill[key], buffs);
                    }
                }
            }
        }
    }
    return characters;
}

function createSkill(skill, buffs) {
    const skipChar = ["(", ")", ".", "according", "evading"]

    let skip = 0;

    const words = skill.split(" ")
    let modified = [];
    for (let [index, word] of words.entries()) {
        if (skipChar.some(char => word.includes(char)) && !word.includes('"') && !word.includes("Dark")) {
            modified.push(word);
            continue;
        }

        if (skip > 0) {
            skip--;
            modified.push(word);
            continue;
        }

        let buffAdded = false;

        for (const buffKey in buffs) {
            const buff = buffs[buffKey];
            const buffName = buff.name.split(" ");

            if (wordMatchesBuff(word, buffName, index, words)) {
                modified.push([buff]);
                modified.push(word);
                buffAdded = true;
                skip = buffName.length - 1;
                break;
            }
        }

        if (!buffAdded) {
            modified.push(word);
        }
    }

    let last = 'b';
    let final = [];

    modified.forEach((word, index) => {
        if (Array.isArray(word)) {
            const buff = word[0];
            last = calculateLast(buff, modified, index, last);
            final.push({ buff: buff.id, type: last });
        } else if (typeof word === 'string') {
            if (final.length === 0 || typeof final[final.length - 1] !== 'string') {
                final.push(word);
            } else {
                final[final.length - 1] += ' ' + word;
            }
        }
    });

    return final;
}

function wordMatchesBuff(word, buffName, index, words) {
    const cancelPrefix = ["of", "highest", "lowest", "Word", "Sound"]
    if (buffName.length === 1) {
        return word.toLowerCase().includes(buffName[0].toLowerCase()) && (index === 0 || !cancelPrefix.some(prefix => words[index - 1].includes(prefix)) || (cancelPrefix.some(prefix => words[index - 1].includes(prefix)) && ["Buff", "among"].includes(words[index + 1])));
    } else if (buffName.length === 2 && !["Technique"].includes(words[index - 1]) && word.toLowerCase().includes(buffName[0].toLowerCase()) && words[index + 1].toLowerCase().includes(buffName[1].toLowerCase())) {
        return true;
    } else if (buffName.length === 3 && word.toLowerCase().includes(buffName[0].toLowerCase()) && words[index + 1].toLowerCase().includes(buffName[1].toLowerCase()) && words[index + 2].toLowerCase().includes(buffName[2].toLowerCase())) {
        return true;
    } else if (buffName.length === 4 && word.toLowerCase().includes(buffName[0].toLowerCase()) && words[index + 1].toLowerCase().includes(buffName[1].toLowerCase()) && words[index + 2].toLowerCase().includes(buffName[2].toLowerCase()) && words[index + 3].toLowerCase().includes(buffName[3].toLowerCase())) {
        return true;
    }
    return false;
}

function calculateLast(buff, words, index, last) {
    const buffImageLength = Object.keys(buff.images).length;
    let prefix = "";
    if (index !== 0) {
        prefix = words[index - 1].toLowerCase();
    }

    let src = "b"
    if (buffImageLength !== 1) {
        if (index !== 0) {
            if (["raises", "increases", "inflicts"].includes(prefix)) {
                if (["DMG Received", "Provoke"].includes(buff.name)) {
                    src = "d"
                }

                if (buff.type.includes("Status Ailment")) {
                    if (words[index + 2] !== "RES") {
                        src = "d"
                    }

                }
            } else if (buff.type.includes("Status Ailment") && index + 2 < words.length) {
                if (words[index + 2] !== "RES") {
                    src = "d"
                }

            } else if (["own"].includes(prefix)) {
                if (["raises", "increases", "inflicts"].includes(words[index - 2])) {
                    if (["DMG Received", "Provoke"].includes(buff.name)) {
                        src = "d"
                    }
                }
            } else if (["and"].includes(prefix)) {
                if (last === "d") {
                    src = "d"
                }
            } else if (["Debuff"].includes(words[index + 2])) {
                src = "d"
            } else if (["lowers", "reduces"].includes(prefix) && !["DMG Received"].includes(buff.name)) {
                src = "d"
            } else if (["Provoke"].includes(buff.name) && ["time"].includes(prefix)) {
                src = "d"
            } else {
                if (!["DMG Received", "Provoke"].includes(buff.name) && buff.type.includes('Status Ailment')) {
                    src = "d"
                }
            }
        }
    } else {
        src = Object.keys(buff.images)[0]
    }
    last = src;

    return last;
}

function Skill({ skill, buffData }) {
    let modified = skill.map(word => {
        if (typeof word === 'object' && word.buff && buffData[word.buff]) {
            const buff = buffData[word.buff];
            const iconClass = (buff.type.includes("Status Ailment") && word.type === 'd') || buff.name === "Invincibility" ? 'buff-icon small' : 'buff-icon';
            return (
                <img
                    key={word.buff + word.type}
                    src={buff.images[word.type]}
                    alt={buff.name}
                    className={iconClass}
                />
            );
        }
        return word;
    });

    return (
        <div className="skill-text">
            {modified.map((item, index) => {
                const key = typeof item === 'string' ? `string-${index}` : `object-${index}`;
                return (
                    <React.Fragment key={key}>
                        {typeof item === 'string' ? (
                            <span className='skill-item'>
                                {item}
                                {modified[index + 1] && typeof modified[index + 1] === 'string' && ' '}
                            </span>
                        ) : (
                            item
                        )}
                    </React.Fragment>
                );
            })}
        </div>
    );
}

export default Skill;